module.exports = __webpack_public_path__ + "img/applicable-scene-2.299831e.png";